export default __webpack_public_path__ + "static/media/drumar.b56e28bf.gif";